import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
// reactstrap components
import {
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';

import { validateEmail as validateE } from '../../../utils/validateEmail';
import SwitchBtn from '../../Common/SwitchBtn/switchBtn';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      rememberMe: false,
      addUsername: false,
      alertBox: true,
      validate: {
        emailState: false,
        passwordState: false,
      },
      showPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
  }

  async submitForm() {
    this.props.login(
      this.state.email,
      this.state.password,
      this.state.rememberMe,
    );
    this.setState({ alertBox: true });
  }

  validatePassword(e) {
    const { validate } = this.state;
    if (this.state.password.length >= 6) {
      validate.passwordState = true;
    } else {
      validate.passwordState = false;
    }
    this.setState({ validate });
  }

  validateEmail(e) {
    const { validate } = this.state;
    validate.emailState = validateE(e);
    this.setState({ validate });
  }

  handleEnter = (event) => {
    if (
      event.key === 'Enter' &&
      this.state.validate.emailState &&
      this.state.validate.passwordState
    ) {
      this.submitForm(event);
    }
  };

  async handleCloseAlert() {
    this.setState({ alertBox: false });
  }

  handleChange = async (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;

    await this.setState({
      [name]: value,
    });
    if (name === 'email') {
      this.validateEmail(target);
    }
    if (name === 'password') {
      this.validatePassword(target);
    }
  };

  async handleSwitchChange() {
    await this.setState({ rememberMe: !this.state.rememberMe });
  }

  componentDidMount() {
    document.addEventListener('keypress', this.handleEnter);
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this.handleEnter);
  }

  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  render() {
    const { email, password } = this.state;
    return (
      <div>
        <div className="login-container text-center">
          <Row className="p-0 m-0">
            {/* image */}
            <Col md={6} className="d-none d-md-block p-0 login-image-container">
              <h1>The only tool for the USAF-wide PFE/SKT exam.</h1>
            </Col>

            {/* form */}

            <Col xs={12} md={6} className="login-form-container">
              <Row className="alert-container">
                {this.props.message && this.props.message !== '' && (
                  <div
                    className={this.state.alertBox ? 'alert' : 'd-none'}
                    role="alert"
                  >
                    <i onClick={this.handleCloseAlert} className="icon-close" />
                    <p className="description">{this.props.message}</p>
                  </div>
                )}
              </Row>

              <h5> Log in to your account</h5>
              <Form role="form">
                <FormGroup className="mb-3">
                  <InputGroup>
                    <Input
                      id="emaiInputId"
                      placeholder="Email Address"
                      type="email"
                      name="email"
                      value={email}
                      valid={this.state.validate.emailState}
                      invalid={
                        this.state.email.length > 0 &&
                        !this.state.validate.emailState
                      }
                      onChange={(e) => this.handleChange(e)}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="mb-3">
                  <InputGroup>
                    <Input
                      id="passwordInputId"
                      placeholder="Password"
                      type={this.state.showPassword ? 'text' : 'password'}
                      name="password"
                      value={password}
                      onChange={(e) => this.handleChange(e)}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText
                        onClick={this.togglePasswordVisibility}
                        style={{ border: '0px' }}
                      >
                        {this.state.showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>

                {/* button rememberMe */}
                <div className="switch-button">
                  <div className="button-section">
                    <button
                      className="w-100 btn login-button"
                      data-test="log-in-button"
                      type="button"
                      disabled={
                        this.props.isLoading ||
                        !this.state.validate.emailState ||
                        !this.state.validate.passwordState
                      }
                      onClick={(e) => this.submitForm(e)}
                    >
                      LOGIN
                    </button>
                  </div>
                  <Row className="remember-me-section">
                    <SwitchBtn
                      checked={this.state.rememberMe}
                      onChange={this.handleSwitchChange}
                    />
                    <p className="float-right"> Remember Me</p>
                  </Row>
                </div>
              </Form>

              {/* footer */}
              <div className="text-center login-footer">
                <hr />
                <p>
                  Don't have an account?
                  <Link
                    className="sign-up-link login-footer-link"
                    to="/auth/sign-up"
                  >
                    Sign Up.
                  </Link>
                </p>
                <Link
                  className="forgot-password-link login-footer-link"
                  to="/forgot-password"
                >
                  Forgot Your Password?
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  handleSubmit: PropTypes.func,
  message: PropTypes.string,
};

export default Login;
